<template>
    <el-select
        :size="size"
        v-model="selectedVal"
        :placeholder="placeholder"
        :default-first-option="defaultFirstOption"
        :clearable="clearable"
        :multiple="multiple"
        :multiple-limit="multipleLimit"
        :disabled="disabled"
        value-key="id"
        @change="onChange"
        >
        <el-option
            v-for="(item,index) in selectOption"
            :name="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
            :key="'select'+item.value+index">
            <slot v-bind:row="item">
                {{ item.label }}
            </slot>
        </el-option>
    </el-select>
</template>
<script>

export default {
    name: "selectPara",
    props: {
        size:{ // 下拉框大小
           type: String,
           default: ""
        },
     
        value: { // v-model绑定值
            type: [String, Array, Number, Boolean],
            default () {
                if (this.multiple) return []
                else return ''
            }
        },
        label: { // label值
            type: [String, Array, Number, Boolean],
            default () {
                if (this.multiple) {
                    return []
                }
                if(!this.multiple) {
                    return ''
                }
            }
        },
       
        placeholder: {
            type: String,
            default: '请选择'
        },
        options: { // 外部传入的options 可代替自带的请求项
            type: Array,
            default () {
                return [];
            }
        },
      
        defaultFirstOption: { // 按回车键 选择第一项
            type: Boolean,
            default: false
        },
        clearable: { // 选项是否可清除
            type: Boolean,
            default: true
        },
        disabled: { // 是否禁用
            type: Boolean,
            default: false
        },
        multiple: { // 是否多选
            type: Boolean,
            default: false
        },
        multipleLimit: { // 多选时用户最多可以选择的项目数，为 0 则不限制
            type: Number,
            default: 0
        },
        filterable: { // 模糊搜索
            type: Boolean,
            default: true
        },
       
        disabledChange: { // 禁用change事件
            type: Boolean,
            default: false,
        },
        disabledKeys: { // 禁止选择的项的key (即value)
            type: Array,
            default() {
                return []
            }
        },
       
    },

    watch:{
        selectedVal(val, oldVal){
                if(val!=oldVal) {
                    this.$emit("input", val);//③组件内对myResult变更后向外部发送事件通知
                }
            },
        options(val,oldVal){
            if(val!=oldVal){
               console.log(this.options,"========")
             this.selectOption = [...this.options];
            }
          
        }
    },
    data() {
        return {
            selectOption: [],
            visible: false,
            label_tmp: null,
        };
    },
    computed:{
        selectedVal:{
             get: function () {
                return this.value
            },
            set: function (val) {
                this.$emit("input", val);
            }

        }
    },
  
    mounted() {
        console.log("options",this.options)
        this.$nextTick(() => {
                this.selectOption = [...this.options];
        })
    },
    methods: {
        onChange(val){
            this.$emit('selectVal',val)
        }
      
    }
}
</script>
